import React from 'react'
import ToolTip from '../../ToolTip/ToolTip';

const PotentialLabel = ({label, subLabel, value, infoText, children}) => {

    return (
        <div style={{marginBottom: "1.5rem"}}>
            <div style={{display: 'flex', gap: "0.5rem", fontSize: '16px', fontWeight: '600'}}>
                {label}
                {infoText && <ToolTip style={{ transform: 'translateX(100%)' }} text={infoText} />}
            </div>
            {subLabel && (<div style={{fontSize: '12px'}} >{subLabel}</div>)}

            <div style={{fontSize: "1.5rem", fontWeight: "bold"}}>
                {value}
            </div>
            {children}
        </div>
    )
}

export default PotentialLabel